import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouteDataService } from '@core/services/route-data.service';
import { AccountEffects } from '@core/states/account/account.effects';
import { BackgroundType } from '@shared/models/route-data.model';
import { AppSettingsService } from '@core/services/app-settings.service';

@Component({
  selector: 'cp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AccountEffects],
})
export class AppComponent implements OnInit {
  showHeader: boolean = false;
  background: BackgroundType = BackgroundType.Main;
  noOffset: boolean = false;
  BackgroundType: typeof BackgroundType = BackgroundType;

  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly routeDataService: RouteDataService,
    private readonly appSettingsService: AppSettingsService,
    private readonly accountEffects: AccountEffects,
  ) {
    this.accountEffects.init();
  }

  ngOnInit(): void {
    this.subscribeToRouteChanges();
    this.appSettingsService.init();
  }

  private subscribeToRouteChanges(): void {
    this.routeDataService.routerDataChanged().subscribe((data) => {
      if (!data) {
        this.background = BackgroundType.Main;
        this.showHeader = true;
        this.noOffset = false;
      } else {
        if (this.background !== data.background) {
          this.background = (data.background as BackgroundType) || BackgroundType.Main;
        }

        this.noOffset = data.noOffset === (true as boolean);
        this.showHeader = data.noHeader !== (true as boolean);
      }

      this.cd.detectChanges();
    });
  }
}
